/**
 * kult-logo-quality.js — gemeinsame Druckqualitäts-Prüfung für hochgeladene Logos (06.10.2026).
 * Genutzt von assets/kult-b2b-mischung.js (Bürokaffee-Konfigurator) und assets/kult-b2b-logo-upload.js (Logo-Box).
 * Eingebunden per <script defer> vor dem jeweiligen Upload-Skript (sections/kult-b2b-mischung*.liquid,
 * snippets/kult-b2b-logo-upload.liquid); mehrfaches Laden ist harmlos.
 *
 * window.KultLogoQuality.check(w, h, type, minPx) → { kind, ok, vector, w, h, min, message, value } oder null
 *   type   'svg' | 'png' | 'jpg' | 'webp' (Original-Datei, nicht der verkleinerte Zuschnitt)
 *   minPx  Mindestmaß der längeren Seite in Pixel (Section-Setting logo_min_px, Default 800)
 *   Regel: SVG ist immer druckfähig (kind 'vector'); Rasterbilder sind druckfähig, wenn max(w, h) ≥ minPx (kind 'ok'),
 *   sonst kind 'low' (nur Vorschau, Druckdatei folgt). Ungültige Maße → null.
 *   message = Satz für die Statuszeile, value = kurzer Wert für Formular, PDF, Ereignis und Warenkorb.
 * Kein Framework, keine externen Skripte.
 */
(function () {
  'use strict';
  if (window.KultLogoQuality) return;

  var DEFAULT_MIN = 800;
  var NUM = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

  function minOf(minPx) {
    var n = parseInt(minPx, 10);
    return isFinite(n) && n >= 100 && n <= 10000 ? n : DEFAULT_MIN;
  }

  function check(w, h, type, minPx) {
    var t = String(type || '').toLowerCase();
    var min = minOf(minPx);
    if (t === 'svg') {
      return { kind: 'vector', ok: true, vector: true, w: 0, h: 0, min: min, message: 'Vektordatei, druckfähig. Wir können direkt damit arbeiten.', value: 'Vektordatei, druckfähig' };
    }
    var pw = Math.round(Number(w) || 0), ph = Math.round(Number(h) || 0);
    if (pw < 1 || ph < 1) return null;
    var dims = NUM.format(pw) + ' × ' + NUM.format(ph) + ' px';
    if (Math.max(pw, ph) >= min) {
      return { kind: 'ok', ok: true, vector: false, w: pw, h: ph, min: min, message: 'Auflösung reicht für den Druck (' + dims + '). Wir können direkt damit arbeiten.', value: 'druckfähig (' + dims + ')' };
    }
    return {
      kind: 'low', ok: false, vector: false, w: pw, h: ph, min: min,
      message: 'Für den Druck reicht die Auflösung nicht (' + dims + ', empfohlen mindestens ' + NUM.format(min) + ' px Breite). Für die Vorschau ist das kein Problem; die Druckdatei senden Sie uns im Nachgang.',
      value: 'nur Vorschau (' + dims + ', Druckdatei folgt)'
    };
  }

  window.KultLogoQuality = { check: check, DEFAULT_MIN: DEFAULT_MIN };
})();
